// This store's markdowns: the cached list straight away, then the server's when
// the till is online, refreshed every REFRESH_MS. A failed call keeps the last
// list (and pricing stays as it was), so an unreachable server never blocks billing.
// With markdowns switched off (FASHION_FEATURES) there are none: list prices only.
import { useEffect, useState } from "react";
import { fashionPosService } from "../../../../services";
import { FASHION_FEATURES } from "../../../../utils/fashion/features";
import { buildMarkdownsQuery, loadCache, readMarkdowns, saveCache } from "../../../../utils/fashion/markdowns";

export const REFRESH_MS = 15 * 60 * 1000;

const NONE = [];

export default function useFashionMarkdowns(tillData, isOnline, enabled = FASHION_FEATURES.markdowns) {
  const bunitId = enabled ? tillData?.tillAccess?.csBunit?.csBunitId : undefined;
  const [markdowns, setMarkdowns] = useState(() => (bunitId ? loadCache(bunitId) : NONE));
  const online = typeof isOnline === "boolean" ? isOnline : typeof navigator === "undefined" || navigator.onLine;

  useEffect(() => {
    if (!bunitId) {
      setMarkdowns(NONE);
      return undefined;
    }
    setMarkdowns(loadCache(bunitId));
    if (!online) return undefined;
    let live = true;
    const load = async () => {
      const rows = readMarkdowns(await fashionPosService(buildMarkdownsQuery(bunitId)));
      if (!live || rows === null) return;
      saveCache(bunitId, rows);
      setMarkdowns(rows);
    };
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, [bunitId, online]);

  return markdowns;
}
